import { Component, Input, OnInit } from '@angular/core';
import { ProgramMassiveUpload, ImportProcessStatus } from '../../../domain/models/ProgramMassiveImport';
import { LazyLoadEvent } from 'primeng/api';
import { DirectSaleProgramGateway } from 'src/app/application/gateway/DirectSaleProgramGateway';
import { get } from 'http';

@Component({
  selector: 'app-program-massive-import-table',
  templateUrl: './program-massive-import-table.component.html',
  styleUrls: ['./program-massive-import-table.component.css']
})
export class ProgramMassiveImportTableComponent implements OnInit {
  imports: ProgramMassiveUpload[] = [];
  totalRecords: number = 0;
  @Input() loading: boolean = false;
  pageSize: number = 5;
  pageNumber: number = 1;
  message: string = '';
  visibleMessage: boolean = false;


  constructor(
    private _directSaleProgramService: DirectSaleProgramGateway
  ) { }

  ngOnInit(): void {
    this.getImports();
  }

  getStatusLabel(status: ImportProcessStatus): string {
    switch (status) {
      case ImportProcessStatus.Pending:
        return 'Pendiente';
      case ImportProcessStatus.Processing:
        return 'Procesando';
      case ImportProcessStatus.Completed:
        return 'Completado';
      case ImportProcessStatus.Error:
        return 'Error';
      case ImportProcessStatus.CompletedWithErrors:
        return 'Completado con errores';
      default:
        return 'Desconocido';
    }
  }

  getStatusClass(status: ImportProcessStatus): string {
    switch (status) {
      case ImportProcessStatus.Pending:
        return 'status-pending';
      case ImportProcessStatus.Processing:
        return 'status-processing';
      case ImportProcessStatus.Completed:
        return 'status-completed';
      case ImportProcessStatus.Error:
        return 'status-error';
      case ImportProcessStatus.CompletedWithErrors:
        return 'status-completed-errors';
      default:
        return '';
    }
  }

  getProgress(item: ProgramMassiveUpload): number {
    if (item.programs === 0 && item.lines === 0) return 0;

    const programProgress = item.programs > 0 ? (item.programsProcessed / item.programs) : 0;
    const lineProgress = item.lines > 0 ? (item.linesProcessed / item.lines) : 0;

    return Math.round(((programProgress + lineProgress) / 2) * 100);
  }

  getImports(pageNumber: number = 1, pageSize: number = this.pageSize) {
    this.loading = true;
    this._directSaleProgramService.getMassiveProgramsImport(pageNumber, pageSize).subscribe({
      next: (response) => {
        this.imports = response.items;
        this.totalRecords = response.totalCount;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching imports:', err);
        this.loading = false;
      }
    });
  }

  showMessage(message: string) {
    // Implementa la lógica para mostrar un mensaje al usuario, por ejemplo, usando un servicio de notificaciones
    this.message = message;
    this.visibleMessage = true;
  }

  getCountriesPaged(event: LazyLoadEvent) {
    const pageNumber = Math.floor(event.first! / event.rows!) + 1;
    const pageSize = event.rows!;

    this.getImports(pageNumber, pageSize);
  }
}
